export default "__VITE_ASSET__DC2ZNo3j__"